/**
 * @generated SignedSource<<219663769257bdbc64b633f20ce31fac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type labelRow_company$data = {
  readonly id: string;
  readonly createdAt: string | null;
  readonly " $fragmentType": "labelRow_company";
};
export type labelRow_company$key = {
  readonly " $data"?: labelRow_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"labelRow_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "labelRow_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "51e5e00ed9d215ea109f170f003bf0a5";

export default node;
